// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/services/agent/chats.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  AgentRunTask,
  BackendDisconnected,
  ChatSessionAction,
  DocumentRegenerateTask,
  FullStateUpdate,
  MessageToken,
  PartialStateUpdate,
  ProcessAttachmentTask,
  RequestProcessedAck,
  SimpleAIAction,
  TokenizedStateUpdate,
  UserMessage,
} from "../../types/ai";
import { ThreadEntity, ThreadExecutionInfo, ThreadInfo, ThreadProgress } from "../../types/threads";

export const protobufPackage = "api.devplan.services.agent.chats";

export interface ExecuteAIActionRequest {
  companyId: number;
  action:
    | { $case: "simpleAction"; value: SimpleAIAction }
    | { $case: "processAttachment"; value: ProcessAttachmentTask }
    | { $case: "documentRegenerate"; value: DocumentRegenerateTask }
    | undefined;
}

export interface ExecuteAIActionResponse {
  response: string;
}

export interface ChatSessionRequest {
  requestId: string;
  message:
    | { $case: "enter"; value: ChatSessionRequest_Enter }
    | { $case: "exit"; value: ChatSessionRequest_Exit }
    | { $case: "sendUserMessage"; value: UserMessage }
    | { $case: "partialStateUpdate"; value: PartialStateUpdate }
    | { $case: "reRunLast"; value: ChatSessionRequest_ReRunLast }
    | { $case: "runAction"; value: ChatSessionAction }
    | undefined;
}

export interface ChatSessionRequest_Enter {
  entity: ThreadEntity | undefined;
}

export interface ChatSessionRequest_Exit {
}

export interface ChatSessionRequest_ReRunLast {
}

export interface ChatSessionResponse {
  message:
    | { $case: "threadInfo"; value: ThreadInfo }
    | { $case: "fullStateUpdate"; value: FullStateUpdate }
    | { $case: "processAck"; value: RequestProcessedAck }
    | { $case: "responseToken"; value: MessageToken }
    | { $case: "tokenStateUpdate"; value: TokenizedStateUpdate }
    | { $case: "backendDisconnected"; value: BackendDisconnected }
    | undefined;
}

export interface RunProjectAgentRequest {
  task: AgentRunTask | undefined;
}

export interface RunProjectAgentResponse {
  response:
    | //
    /** Id of the thread associated with the request */
    { $case: "threadId"; value: string }
    | //
    /** New token generated for the. Once all token are sent, the request will finish. */
    { $case: "token"; value: MessageToken }
    | //
    /** Error message for failed operations */
    { $case: "error"; value: string }
    | undefined;
}

export interface GetThreadExecutionInfosRequest {
  companyId: number;
}

export interface GetThreadExecutionInfosResponse {
  update: { $case: "activityUpdate"; value: ThreadsActivityUpdate } | {
    $case: "progressUpdate";
    value: ThreadProgressUpdate;
  } | undefined;
}

export interface ThreadsActivityUpdate {
  active: ThreadExecutionInfo[];
  /** Ids of the deactivated threads. */
  deactivated: string[];
  fullSnapshot: boolean;
}

export interface ThreadProgressUpdate {
  threadId: string;
  progress: ThreadProgress | undefined;
}

export interface ConfirmInitialPrdSectionsRequest {
  documentId: string;
  companyId: number;
}

export interface ConfirmInitialPrdSectionsResponse {
}

export interface RegenerateSuggestionsRequest {
  documentId: string;
  companyId: number;
}

export interface RegenerateSuggestionsResponse {
}

export interface DeleteChatForDocumentRequest {
  documentId: string;
  companyId: number;
}

export interface DeleteChatForDocumentResponse {
}

export interface WsStartChatSessionRequest {
  id: string;
  entity: ThreadEntity | undefined;
}

export interface WsEndChatSessionRequest {
  id: string;
}

export interface WsChatSessionRequest {
  id: string;
  request: ChatSessionRequest | undefined;
}

export interface WsCompanyInfoSubscribeRequest {
  companyId: number;
  subscriptionId: string;
}

export interface WsCompanyInfoUnsubscribeRequest {
  companyId: number;
  subscriptionId: string;
}

export interface WsRunProjectAgentRequest {
  requestId: string;
  request: RunProjectAgentRequest | undefined;
}

export interface WsRunProjectAgentResponse {
  requestId: string;
  response: RunProjectAgentResponse | undefined;
}

export interface WsChatSessionResponse {
  id: string;
  response?: ChatSessionResponse | undefined;
  error?: string | undefined;
}

export interface WsAck {
  ackId: string;
}

export interface WsResponse {
  type:
    | { $case: "runProjectAgent"; value: WsRunProjectAgentResponse }
    | { $case: "chatSession"; value: WsChatSessionResponse }
    | { $case: "ack"; value: WsAck }
    | { $case: "threadActivityUpdate"; value: ThreadsActivityUpdate }
    | { $case: "threadProgressUpdate"; value: ThreadProgressUpdate }
    | undefined;
}

function createBaseExecuteAIActionRequest(): ExecuteAIActionRequest {
  return { companyId: 0, action: undefined };
}

export const ExecuteAIActionRequest: MessageFns<ExecuteAIActionRequest> = {
  encode(message: ExecuteAIActionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    switch (message.action?.$case) {
      case "simpleAction":
        SimpleAIAction.encode(message.action.value, writer.uint32(18).fork()).join();
        break;
      case "processAttachment":
        ProcessAttachmentTask.encode(message.action.value, writer.uint32(26).fork()).join();
        break;
      case "documentRegenerate":
        DocumentRegenerateTask.encode(message.action.value, writer.uint32(34).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecuteAIActionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExecuteAIActionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.action = { $case: "simpleAction", value: SimpleAIAction.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.action = { $case: "processAttachment", value: ProcessAttachmentTask.decode(reader, reader.uint32()) };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.action = {
            $case: "documentRegenerate",
            value: DocumentRegenerateTask.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExecuteAIActionRequest {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      action: isSet(object.simpleAction)
        ? { $case: "simpleAction", value: SimpleAIAction.fromJSON(object.simpleAction) }
        : isSet(object.simple_action)
        ? { $case: "simpleAction", value: SimpleAIAction.fromJSON(object.simple_action) }
        : isSet(object.processAttachment)
        ? { $case: "processAttachment", value: ProcessAttachmentTask.fromJSON(object.processAttachment) }
        : isSet(object.process_attachment)
        ? { $case: "processAttachment", value: ProcessAttachmentTask.fromJSON(object.process_attachment) }
        : isSet(object.documentRegenerate)
        ? { $case: "documentRegenerate", value: DocumentRegenerateTask.fromJSON(object.documentRegenerate) }
        : isSet(object.document_regenerate)
        ? { $case: "documentRegenerate", value: DocumentRegenerateTask.fromJSON(object.document_regenerate) }
        : undefined,
    };
  },

  toJSON(message: ExecuteAIActionRequest): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.action?.$case === "simpleAction") {
      obj.simpleAction = SimpleAIAction.toJSON(message.action.value);
    } else if (message.action?.$case === "processAttachment") {
      obj.processAttachment = ProcessAttachmentTask.toJSON(message.action.value);
    } else if (message.action?.$case === "documentRegenerate") {
      obj.documentRegenerate = DocumentRegenerateTask.toJSON(message.action.value);
    }
    return obj;
  },

  create(base?: DeepPartial<ExecuteAIActionRequest>): ExecuteAIActionRequest {
    return ExecuteAIActionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ExecuteAIActionRequest>): ExecuteAIActionRequest {
    const message = createBaseExecuteAIActionRequest();
    message.companyId = object.companyId ?? 0;
    switch (object.action?.$case) {
      case "simpleAction": {
        if (object.action?.value !== undefined && object.action?.value !== null) {
          message.action = { $case: "simpleAction", value: SimpleAIAction.fromPartial(object.action.value) };
        }
        break;
      }
      case "processAttachment": {
        if (object.action?.value !== undefined && object.action?.value !== null) {
          message.action = {
            $case: "processAttachment",
            value: ProcessAttachmentTask.fromPartial(object.action.value),
          };
        }
        break;
      }
      case "documentRegenerate": {
        if (object.action?.value !== undefined && object.action?.value !== null) {
          message.action = {
            $case: "documentRegenerate",
            value: DocumentRegenerateTask.fromPartial(object.action.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseExecuteAIActionResponse(): ExecuteAIActionResponse {
  return { response: "" };
}

export const ExecuteAIActionResponse: MessageFns<ExecuteAIActionResponse> = {
  encode(message: ExecuteAIActionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.response !== "") {
      writer.uint32(10).string(message.response);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecuteAIActionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExecuteAIActionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.response = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExecuteAIActionResponse {
    return { response: isSet(object.response) ? globalThis.String(object.response) : "" };
  },

  toJSON(message: ExecuteAIActionResponse): unknown {
    const obj: any = {};
    if (message.response !== "") {
      obj.response = message.response;
    }
    return obj;
  },

  create(base?: DeepPartial<ExecuteAIActionResponse>): ExecuteAIActionResponse {
    return ExecuteAIActionResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ExecuteAIActionResponse>): ExecuteAIActionResponse {
    const message = createBaseExecuteAIActionResponse();
    message.response = object.response ?? "";
    return message;
  },
};

function createBaseChatSessionRequest(): ChatSessionRequest {
  return { requestId: "", message: undefined };
}

export const ChatSessionRequest: MessageFns<ChatSessionRequest> = {
  encode(message: ChatSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    switch (message.message?.$case) {
      case "enter":
        ChatSessionRequest_Enter.encode(message.message.value, writer.uint32(810).fork()).join();
        break;
      case "exit":
        ChatSessionRequest_Exit.encode(message.message.value, writer.uint32(818).fork()).join();
        break;
      case "sendUserMessage":
        UserMessage.encode(message.message.value, writer.uint32(826).fork()).join();
        break;
      case "partialStateUpdate":
        PartialStateUpdate.encode(message.message.value, writer.uint32(834).fork()).join();
        break;
      case "reRunLast":
        ChatSessionRequest_ReRunLast.encode(message.message.value, writer.uint32(842).fork()).join();
        break;
      case "runAction":
        ChatSessionAction.encode(message.message.value, writer.uint32(850).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.message = { $case: "enter", value: ChatSessionRequest_Enter.decode(reader, reader.uint32()) };
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.message = { $case: "exit", value: ChatSessionRequest_Exit.decode(reader, reader.uint32()) };
          continue;
        }
        case 103: {
          if (tag !== 826) {
            break;
          }

          message.message = { $case: "sendUserMessage", value: UserMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 104: {
          if (tag !== 834) {
            break;
          }

          message.message = { $case: "partialStateUpdate", value: PartialStateUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 105: {
          if (tag !== 842) {
            break;
          }

          message.message = { $case: "reRunLast", value: ChatSessionRequest_ReRunLast.decode(reader, reader.uint32()) };
          continue;
        }
        case 106: {
          if (tag !== 850) {
            break;
          }

          message.message = { $case: "runAction", value: ChatSessionAction.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatSessionRequest {
    return {
      requestId: isSet(object.requestId)
        ? globalThis.String(object.requestId)
        : isSet(object.request_id)
        ? globalThis.String(object.request_id)
        : "",
      message: isSet(object.enter)
        ? { $case: "enter", value: ChatSessionRequest_Enter.fromJSON(object.enter) }
        : isSet(object.exit)
        ? { $case: "exit", value: ChatSessionRequest_Exit.fromJSON(object.exit) }
        : isSet(object.sendUserMessage)
        ? { $case: "sendUserMessage", value: UserMessage.fromJSON(object.sendUserMessage) }
        : isSet(object.send_user_message)
        ? { $case: "sendUserMessage", value: UserMessage.fromJSON(object.send_user_message) }
        : isSet(object.partialStateUpdate)
        ? { $case: "partialStateUpdate", value: PartialStateUpdate.fromJSON(object.partialStateUpdate) }
        : isSet(object.partial_state_update)
        ? { $case: "partialStateUpdate", value: PartialStateUpdate.fromJSON(object.partial_state_update) }
        : isSet(object.reRunLast)
        ? { $case: "reRunLast", value: ChatSessionRequest_ReRunLast.fromJSON(object.reRunLast) }
        : isSet(object.re_run_last)
        ? { $case: "reRunLast", value: ChatSessionRequest_ReRunLast.fromJSON(object.re_run_last) }
        : isSet(object.runAction)
        ? { $case: "runAction", value: ChatSessionAction.fromJSON(object.runAction) }
        : isSet(object.run_action)
        ? { $case: "runAction", value: ChatSessionAction.fromJSON(object.run_action) }
        : undefined,
    };
  },

  toJSON(message: ChatSessionRequest): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.message?.$case === "enter") {
      obj.enter = ChatSessionRequest_Enter.toJSON(message.message.value);
    } else if (message.message?.$case === "exit") {
      obj.exit = ChatSessionRequest_Exit.toJSON(message.message.value);
    } else if (message.message?.$case === "sendUserMessage") {
      obj.sendUserMessage = UserMessage.toJSON(message.message.value);
    } else if (message.message?.$case === "partialStateUpdate") {
      obj.partialStateUpdate = PartialStateUpdate.toJSON(message.message.value);
    } else if (message.message?.$case === "reRunLast") {
      obj.reRunLast = ChatSessionRequest_ReRunLast.toJSON(message.message.value);
    } else if (message.message?.$case === "runAction") {
      obj.runAction = ChatSessionAction.toJSON(message.message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<ChatSessionRequest>): ChatSessionRequest {
    return ChatSessionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChatSessionRequest>): ChatSessionRequest {
    const message = createBaseChatSessionRequest();
    message.requestId = object.requestId ?? "";
    switch (object.message?.$case) {
      case "enter": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = { $case: "enter", value: ChatSessionRequest_Enter.fromPartial(object.message.value) };
        }
        break;
      }
      case "exit": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = { $case: "exit", value: ChatSessionRequest_Exit.fromPartial(object.message.value) };
        }
        break;
      }
      case "sendUserMessage": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = { $case: "sendUserMessage", value: UserMessage.fromPartial(object.message.value) };
        }
        break;
      }
      case "partialStateUpdate": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = {
            $case: "partialStateUpdate",
            value: PartialStateUpdate.fromPartial(object.message.value),
          };
        }
        break;
      }
      case "reRunLast": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = {
            $case: "reRunLast",
            value: ChatSessionRequest_ReRunLast.fromPartial(object.message.value),
          };
        }
        break;
      }
      case "runAction": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = { $case: "runAction", value: ChatSessionAction.fromPartial(object.message.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseChatSessionRequest_Enter(): ChatSessionRequest_Enter {
  return { entity: undefined };
}

export const ChatSessionRequest_Enter: MessageFns<ChatSessionRequest_Enter> = {
  encode(message: ChatSessionRequest_Enter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.entity !== undefined) {
      ThreadEntity.encode(message.entity, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatSessionRequest_Enter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatSessionRequest_Enter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entity = ThreadEntity.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatSessionRequest_Enter {
    return { entity: isSet(object.entity) ? ThreadEntity.fromJSON(object.entity) : undefined };
  },

  toJSON(message: ChatSessionRequest_Enter): unknown {
    const obj: any = {};
    if (message.entity !== undefined) {
      obj.entity = ThreadEntity.toJSON(message.entity);
    }
    return obj;
  },

  create(base?: DeepPartial<ChatSessionRequest_Enter>): ChatSessionRequest_Enter {
    return ChatSessionRequest_Enter.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChatSessionRequest_Enter>): ChatSessionRequest_Enter {
    const message = createBaseChatSessionRequest_Enter();
    message.entity = (object.entity !== undefined && object.entity !== null)
      ? ThreadEntity.fromPartial(object.entity)
      : undefined;
    return message;
  },
};

function createBaseChatSessionRequest_Exit(): ChatSessionRequest_Exit {
  return {};
}

export const ChatSessionRequest_Exit: MessageFns<ChatSessionRequest_Exit> = {
  encode(_: ChatSessionRequest_Exit, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatSessionRequest_Exit {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatSessionRequest_Exit();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ChatSessionRequest_Exit {
    return {};
  },

  toJSON(_: ChatSessionRequest_Exit): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ChatSessionRequest_Exit>): ChatSessionRequest_Exit {
    return ChatSessionRequest_Exit.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ChatSessionRequest_Exit>): ChatSessionRequest_Exit {
    const message = createBaseChatSessionRequest_Exit();
    return message;
  },
};

function createBaseChatSessionRequest_ReRunLast(): ChatSessionRequest_ReRunLast {
  return {};
}

export const ChatSessionRequest_ReRunLast: MessageFns<ChatSessionRequest_ReRunLast> = {
  encode(_: ChatSessionRequest_ReRunLast, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatSessionRequest_ReRunLast {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatSessionRequest_ReRunLast();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ChatSessionRequest_ReRunLast {
    return {};
  },

  toJSON(_: ChatSessionRequest_ReRunLast): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ChatSessionRequest_ReRunLast>): ChatSessionRequest_ReRunLast {
    return ChatSessionRequest_ReRunLast.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ChatSessionRequest_ReRunLast>): ChatSessionRequest_ReRunLast {
    const message = createBaseChatSessionRequest_ReRunLast();
    return message;
  },
};

function createBaseChatSessionResponse(): ChatSessionResponse {
  return { message: undefined };
}

export const ChatSessionResponse: MessageFns<ChatSessionResponse> = {
  encode(message: ChatSessionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "threadInfo":
        ThreadInfo.encode(message.message.value, writer.uint32(10).fork()).join();
        break;
      case "fullStateUpdate":
        FullStateUpdate.encode(message.message.value, writer.uint32(18).fork()).join();
        break;
      case "processAck":
        RequestProcessedAck.encode(message.message.value, writer.uint32(26).fork()).join();
        break;
      case "responseToken":
        MessageToken.encode(message.message.value, writer.uint32(34).fork()).join();
        break;
      case "tokenStateUpdate":
        TokenizedStateUpdate.encode(message.message.value, writer.uint32(42).fork()).join();
        break;
      case "backendDisconnected":
        BackendDisconnected.encode(message.message.value, writer.uint32(50).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatSessionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = { $case: "threadInfo", value: ThreadInfo.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = { $case: "fullStateUpdate", value: FullStateUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = { $case: "processAck", value: RequestProcessedAck.decode(reader, reader.uint32()) };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = { $case: "responseToken", value: MessageToken.decode(reader, reader.uint32()) };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.message = { $case: "tokenStateUpdate", value: TokenizedStateUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.message = {
            $case: "backendDisconnected",
            value: BackendDisconnected.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatSessionResponse {
    return {
      message: isSet(object.threadInfo)
        ? { $case: "threadInfo", value: ThreadInfo.fromJSON(object.threadInfo) }
        : isSet(object.thread_info)
        ? { $case: "threadInfo", value: ThreadInfo.fromJSON(object.thread_info) }
        : isSet(object.fullStateUpdate)
        ? { $case: "fullStateUpdate", value: FullStateUpdate.fromJSON(object.fullStateUpdate) }
        : isSet(object.full_state_update)
        ? { $case: "fullStateUpdate", value: FullStateUpdate.fromJSON(object.full_state_update) }
        : isSet(object.processAck)
        ? { $case: "processAck", value: RequestProcessedAck.fromJSON(object.processAck) }
        : isSet(object.process_ack)
        ? { $case: "processAck", value: RequestProcessedAck.fromJSON(object.process_ack) }
        : isSet(object.responseToken)
        ? { $case: "responseToken", value: MessageToken.fromJSON(object.responseToken) }
        : isSet(object.response_token)
        ? { $case: "responseToken", value: MessageToken.fromJSON(object.response_token) }
        : isSet(object.tokenStateUpdate)
        ? { $case: "tokenStateUpdate", value: TokenizedStateUpdate.fromJSON(object.tokenStateUpdate) }
        : isSet(object.token_state_update)
        ? { $case: "tokenStateUpdate", value: TokenizedStateUpdate.fromJSON(object.token_state_update) }
        : isSet(object.backendDisconnected)
        ? { $case: "backendDisconnected", value: BackendDisconnected.fromJSON(object.backendDisconnected) }
        : isSet(object.backend_disconnected)
        ? { $case: "backendDisconnected", value: BackendDisconnected.fromJSON(object.backend_disconnected) }
        : undefined,
    };
  },

  toJSON(message: ChatSessionResponse): unknown {
    const obj: any = {};
    if (message.message?.$case === "threadInfo") {
      obj.threadInfo = ThreadInfo.toJSON(message.message.value);
    } else if (message.message?.$case === "fullStateUpdate") {
      obj.fullStateUpdate = FullStateUpdate.toJSON(message.message.value);
    } else if (message.message?.$case === "processAck") {
      obj.processAck = RequestProcessedAck.toJSON(message.message.value);
    } else if (message.message?.$case === "responseToken") {
      obj.responseToken = MessageToken.toJSON(message.message.value);
    } else if (message.message?.$case === "tokenStateUpdate") {
      obj.tokenStateUpdate = TokenizedStateUpdate.toJSON(message.message.value);
    } else if (message.message?.$case === "backendDisconnected") {
      obj.backendDisconnected = BackendDisconnected.toJSON(message.message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<ChatSessionResponse>): ChatSessionResponse {
    return ChatSessionResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChatSessionResponse>): ChatSessionResponse {
    const message = createBaseChatSessionResponse();
    switch (object.message?.$case) {
      case "threadInfo": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = { $case: "threadInfo", value: ThreadInfo.fromPartial(object.message.value) };
        }
        break;
      }
      case "fullStateUpdate": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = { $case: "fullStateUpdate", value: FullStateUpdate.fromPartial(object.message.value) };
        }
        break;
      }
      case "processAck": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = { $case: "processAck", value: RequestProcessedAck.fromPartial(object.message.value) };
        }
        break;
      }
      case "responseToken": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = { $case: "responseToken", value: MessageToken.fromPartial(object.message.value) };
        }
        break;
      }
      case "tokenStateUpdate": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = {
            $case: "tokenStateUpdate",
            value: TokenizedStateUpdate.fromPartial(object.message.value),
          };
        }
        break;
      }
      case "backendDisconnected": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = {
            $case: "backendDisconnected",
            value: BackendDisconnected.fromPartial(object.message.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseRunProjectAgentRequest(): RunProjectAgentRequest {
  return { task: undefined };
}

export const RunProjectAgentRequest: MessageFns<RunProjectAgentRequest> = {
  encode(message: RunProjectAgentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.task !== undefined) {
      AgentRunTask.encode(message.task, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunProjectAgentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunProjectAgentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.task = AgentRunTask.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunProjectAgentRequest {
    return { task: isSet(object.task) ? AgentRunTask.fromJSON(object.task) : undefined };
  },

  toJSON(message: RunProjectAgentRequest): unknown {
    const obj: any = {};
    if (message.task !== undefined) {
      obj.task = AgentRunTask.toJSON(message.task);
    }
    return obj;
  },

  create(base?: DeepPartial<RunProjectAgentRequest>): RunProjectAgentRequest {
    return RunProjectAgentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RunProjectAgentRequest>): RunProjectAgentRequest {
    const message = createBaseRunProjectAgentRequest();
    message.task = (object.task !== undefined && object.task !== null)
      ? AgentRunTask.fromPartial(object.task)
      : undefined;
    return message;
  },
};

function createBaseRunProjectAgentResponse(): RunProjectAgentResponse {
  return { response: undefined };
}

export const RunProjectAgentResponse: MessageFns<RunProjectAgentResponse> = {
  encode(message: RunProjectAgentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.response?.$case) {
      case "threadId":
        writer.uint32(10).string(message.response.value);
        break;
      case "token":
        MessageToken.encode(message.response.value, writer.uint32(18).fork()).join();
        break;
      case "error":
        writer.uint32(26).string(message.response.value);
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunProjectAgentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunProjectAgentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.response = { $case: "threadId", value: reader.string() };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.response = { $case: "token", value: MessageToken.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.response = { $case: "error", value: reader.string() };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunProjectAgentResponse {
    return {
      response: isSet(object.threadId)
        ? { $case: "threadId", value: globalThis.String(object.threadId) }
        : isSet(object.thread_id)
        ? { $case: "threadId", value: globalThis.String(object.thread_id) }
        : isSet(object.token)
        ? { $case: "token", value: MessageToken.fromJSON(object.token) }
        : isSet(object.error)
        ? { $case: "error", value: globalThis.String(object.error) }
        : undefined,
    };
  },

  toJSON(message: RunProjectAgentResponse): unknown {
    const obj: any = {};
    if (message.response?.$case === "threadId") {
      obj.threadId = message.response.value;
    } else if (message.response?.$case === "token") {
      obj.token = MessageToken.toJSON(message.response.value);
    } else if (message.response?.$case === "error") {
      obj.error = message.response.value;
    }
    return obj;
  },

  create(base?: DeepPartial<RunProjectAgentResponse>): RunProjectAgentResponse {
    return RunProjectAgentResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RunProjectAgentResponse>): RunProjectAgentResponse {
    const message = createBaseRunProjectAgentResponse();
    switch (object.response?.$case) {
      case "threadId": {
        if (object.response?.value !== undefined && object.response?.value !== null) {
          message.response = { $case: "threadId", value: object.response.value };
        }
        break;
      }
      case "token": {
        if (object.response?.value !== undefined && object.response?.value !== null) {
          message.response = { $case: "token", value: MessageToken.fromPartial(object.response.value) };
        }
        break;
      }
      case "error": {
        if (object.response?.value !== undefined && object.response?.value !== null) {
          message.response = { $case: "error", value: object.response.value };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseGetThreadExecutionInfosRequest(): GetThreadExecutionInfosRequest {
  return { companyId: 0 };
}

export const GetThreadExecutionInfosRequest: MessageFns<GetThreadExecutionInfosRequest> = {
  encode(message: GetThreadExecutionInfosRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetThreadExecutionInfosRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetThreadExecutionInfosRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetThreadExecutionInfosRequest {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: GetThreadExecutionInfosRequest): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<GetThreadExecutionInfosRequest>): GetThreadExecutionInfosRequest {
    return GetThreadExecutionInfosRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetThreadExecutionInfosRequest>): GetThreadExecutionInfosRequest {
    const message = createBaseGetThreadExecutionInfosRequest();
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseGetThreadExecutionInfosResponse(): GetThreadExecutionInfosResponse {
  return { update: undefined };
}

export const GetThreadExecutionInfosResponse: MessageFns<GetThreadExecutionInfosResponse> = {
  encode(message: GetThreadExecutionInfosResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.update?.$case) {
      case "activityUpdate":
        ThreadsActivityUpdate.encode(message.update.value, writer.uint32(10).fork()).join();
        break;
      case "progressUpdate":
        ThreadProgressUpdate.encode(message.update.value, writer.uint32(18).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetThreadExecutionInfosResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetThreadExecutionInfosResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.update = { $case: "activityUpdate", value: ThreadsActivityUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.update = { $case: "progressUpdate", value: ThreadProgressUpdate.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetThreadExecutionInfosResponse {
    return {
      update: isSet(object.activityUpdate)
        ? { $case: "activityUpdate", value: ThreadsActivityUpdate.fromJSON(object.activityUpdate) }
        : isSet(object.activity_update)
        ? { $case: "activityUpdate", value: ThreadsActivityUpdate.fromJSON(object.activity_update) }
        : isSet(object.progressUpdate)
        ? { $case: "progressUpdate", value: ThreadProgressUpdate.fromJSON(object.progressUpdate) }
        : isSet(object.progress_update)
        ? { $case: "progressUpdate", value: ThreadProgressUpdate.fromJSON(object.progress_update) }
        : undefined,
    };
  },

  toJSON(message: GetThreadExecutionInfosResponse): unknown {
    const obj: any = {};
    if (message.update?.$case === "activityUpdate") {
      obj.activityUpdate = ThreadsActivityUpdate.toJSON(message.update.value);
    } else if (message.update?.$case === "progressUpdate") {
      obj.progressUpdate = ThreadProgressUpdate.toJSON(message.update.value);
    }
    return obj;
  },

  create(base?: DeepPartial<GetThreadExecutionInfosResponse>): GetThreadExecutionInfosResponse {
    return GetThreadExecutionInfosResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetThreadExecutionInfosResponse>): GetThreadExecutionInfosResponse {
    const message = createBaseGetThreadExecutionInfosResponse();
    switch (object.update?.$case) {
      case "activityUpdate": {
        if (object.update?.value !== undefined && object.update?.value !== null) {
          message.update = { $case: "activityUpdate", value: ThreadsActivityUpdate.fromPartial(object.update.value) };
        }
        break;
      }
      case "progressUpdate": {
        if (object.update?.value !== undefined && object.update?.value !== null) {
          message.update = { $case: "progressUpdate", value: ThreadProgressUpdate.fromPartial(object.update.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseThreadsActivityUpdate(): ThreadsActivityUpdate {
  return { active: [], deactivated: [], fullSnapshot: false };
}

export const ThreadsActivityUpdate: MessageFns<ThreadsActivityUpdate> = {
  encode(message: ThreadsActivityUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.active) {
      ThreadExecutionInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.deactivated) {
      writer.uint32(18).string(v!);
    }
    if (message.fullSnapshot !== false) {
      writer.uint32(24).bool(message.fullSnapshot);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ThreadsActivityUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThreadsActivityUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.active.push(ThreadExecutionInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deactivated.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fullSnapshot = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThreadsActivityUpdate {
    return {
      active: globalThis.Array.isArray(object?.active)
        ? object.active.map((e: any) => ThreadExecutionInfo.fromJSON(e))
        : [],
      deactivated: globalThis.Array.isArray(object?.deactivated)
        ? object.deactivated.map((e: any) => globalThis.String(e))
        : [],
      fullSnapshot: isSet(object.fullSnapshot)
        ? globalThis.Boolean(object.fullSnapshot)
        : isSet(object.full_snapshot)
        ? globalThis.Boolean(object.full_snapshot)
        : false,
    };
  },

  toJSON(message: ThreadsActivityUpdate): unknown {
    const obj: any = {};
    if (message.active?.length) {
      obj.active = message.active.map((e) => ThreadExecutionInfo.toJSON(e));
    }
    if (message.deactivated?.length) {
      obj.deactivated = message.deactivated;
    }
    if (message.fullSnapshot !== false) {
      obj.fullSnapshot = message.fullSnapshot;
    }
    return obj;
  },

  create(base?: DeepPartial<ThreadsActivityUpdate>): ThreadsActivityUpdate {
    return ThreadsActivityUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ThreadsActivityUpdate>): ThreadsActivityUpdate {
    const message = createBaseThreadsActivityUpdate();
    message.active = object.active?.map((e) => ThreadExecutionInfo.fromPartial(e)) || [];
    message.deactivated = object.deactivated?.map((e) => e) || [];
    message.fullSnapshot = object.fullSnapshot ?? false;
    return message;
  },
};

function createBaseThreadProgressUpdate(): ThreadProgressUpdate {
  return { threadId: "", progress: undefined };
}

export const ThreadProgressUpdate: MessageFns<ThreadProgressUpdate> = {
  encode(message: ThreadProgressUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.threadId !== "") {
      writer.uint32(10).string(message.threadId);
    }
    if (message.progress !== undefined) {
      ThreadProgress.encode(message.progress, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ThreadProgressUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThreadProgressUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.progress = ThreadProgress.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThreadProgressUpdate {
    return {
      threadId: isSet(object.threadId)
        ? globalThis.String(object.threadId)
        : isSet(object.thread_id)
        ? globalThis.String(object.thread_id)
        : "",
      progress: isSet(object.progress) ? ThreadProgress.fromJSON(object.progress) : undefined,
    };
  },

  toJSON(message: ThreadProgressUpdate): unknown {
    const obj: any = {};
    if (message.threadId !== "") {
      obj.threadId = message.threadId;
    }
    if (message.progress !== undefined) {
      obj.progress = ThreadProgress.toJSON(message.progress);
    }
    return obj;
  },

  create(base?: DeepPartial<ThreadProgressUpdate>): ThreadProgressUpdate {
    return ThreadProgressUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ThreadProgressUpdate>): ThreadProgressUpdate {
    const message = createBaseThreadProgressUpdate();
    message.threadId = object.threadId ?? "";
    message.progress = (object.progress !== undefined && object.progress !== null)
      ? ThreadProgress.fromPartial(object.progress)
      : undefined;
    return message;
  },
};

function createBaseConfirmInitialPrdSectionsRequest(): ConfirmInitialPrdSectionsRequest {
  return { documentId: "", companyId: 0 };
}

export const ConfirmInitialPrdSectionsRequest: MessageFns<ConfirmInitialPrdSectionsRequest> = {
  encode(message: ConfirmInitialPrdSectionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.documentId !== "") {
      writer.uint32(10).string(message.documentId);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmInitialPrdSectionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfirmInitialPrdSectionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfirmInitialPrdSectionsRequest {
    return {
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: ConfirmInitialPrdSectionsRequest): unknown {
    const obj: any = {};
    if (message.documentId !== "") {
      obj.documentId = message.documentId;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<ConfirmInitialPrdSectionsRequest>): ConfirmInitialPrdSectionsRequest {
    return ConfirmInitialPrdSectionsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ConfirmInitialPrdSectionsRequest>): ConfirmInitialPrdSectionsRequest {
    const message = createBaseConfirmInitialPrdSectionsRequest();
    message.documentId = object.documentId ?? "";
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseConfirmInitialPrdSectionsResponse(): ConfirmInitialPrdSectionsResponse {
  return {};
}

export const ConfirmInitialPrdSectionsResponse: MessageFns<ConfirmInitialPrdSectionsResponse> = {
  encode(_: ConfirmInitialPrdSectionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmInitialPrdSectionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfirmInitialPrdSectionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ConfirmInitialPrdSectionsResponse {
    return {};
  },

  toJSON(_: ConfirmInitialPrdSectionsResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ConfirmInitialPrdSectionsResponse>): ConfirmInitialPrdSectionsResponse {
    return ConfirmInitialPrdSectionsResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ConfirmInitialPrdSectionsResponse>): ConfirmInitialPrdSectionsResponse {
    const message = createBaseConfirmInitialPrdSectionsResponse();
    return message;
  },
};

function createBaseRegenerateSuggestionsRequest(): RegenerateSuggestionsRequest {
  return { documentId: "", companyId: 0 };
}

export const RegenerateSuggestionsRequest: MessageFns<RegenerateSuggestionsRequest> = {
  encode(message: RegenerateSuggestionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.documentId !== "") {
      writer.uint32(10).string(message.documentId);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegenerateSuggestionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegenerateSuggestionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegenerateSuggestionsRequest {
    return {
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: RegenerateSuggestionsRequest): unknown {
    const obj: any = {};
    if (message.documentId !== "") {
      obj.documentId = message.documentId;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<RegenerateSuggestionsRequest>): RegenerateSuggestionsRequest {
    return RegenerateSuggestionsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RegenerateSuggestionsRequest>): RegenerateSuggestionsRequest {
    const message = createBaseRegenerateSuggestionsRequest();
    message.documentId = object.documentId ?? "";
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseRegenerateSuggestionsResponse(): RegenerateSuggestionsResponse {
  return {};
}

export const RegenerateSuggestionsResponse: MessageFns<RegenerateSuggestionsResponse> = {
  encode(_: RegenerateSuggestionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegenerateSuggestionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegenerateSuggestionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RegenerateSuggestionsResponse {
    return {};
  },

  toJSON(_: RegenerateSuggestionsResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<RegenerateSuggestionsResponse>): RegenerateSuggestionsResponse {
    return RegenerateSuggestionsResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<RegenerateSuggestionsResponse>): RegenerateSuggestionsResponse {
    const message = createBaseRegenerateSuggestionsResponse();
    return message;
  },
};

function createBaseDeleteChatForDocumentRequest(): DeleteChatForDocumentRequest {
  return { documentId: "", companyId: 0 };
}

export const DeleteChatForDocumentRequest: MessageFns<DeleteChatForDocumentRequest> = {
  encode(message: DeleteChatForDocumentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.documentId !== "") {
      writer.uint32(10).string(message.documentId);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteChatForDocumentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteChatForDocumentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteChatForDocumentRequest {
    return {
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: DeleteChatForDocumentRequest): unknown {
    const obj: any = {};
    if (message.documentId !== "") {
      obj.documentId = message.documentId;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteChatForDocumentRequest>): DeleteChatForDocumentRequest {
    return DeleteChatForDocumentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteChatForDocumentRequest>): DeleteChatForDocumentRequest {
    const message = createBaseDeleteChatForDocumentRequest();
    message.documentId = object.documentId ?? "";
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseDeleteChatForDocumentResponse(): DeleteChatForDocumentResponse {
  return {};
}

export const DeleteChatForDocumentResponse: MessageFns<DeleteChatForDocumentResponse> = {
  encode(_: DeleteChatForDocumentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteChatForDocumentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteChatForDocumentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteChatForDocumentResponse {
    return {};
  },

  toJSON(_: DeleteChatForDocumentResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<DeleteChatForDocumentResponse>): DeleteChatForDocumentResponse {
    return DeleteChatForDocumentResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<DeleteChatForDocumentResponse>): DeleteChatForDocumentResponse {
    const message = createBaseDeleteChatForDocumentResponse();
    return message;
  },
};

function createBaseWsStartChatSessionRequest(): WsStartChatSessionRequest {
  return { id: "", entity: undefined };
}

export const WsStartChatSessionRequest: MessageFns<WsStartChatSessionRequest> = {
  encode(message: WsStartChatSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.entity !== undefined) {
      ThreadEntity.encode(message.entity, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WsStartChatSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWsStartChatSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.entity = ThreadEntity.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WsStartChatSessionRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      entity: isSet(object.entity) ? ThreadEntity.fromJSON(object.entity) : undefined,
    };
  },

  toJSON(message: WsStartChatSessionRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.entity !== undefined) {
      obj.entity = ThreadEntity.toJSON(message.entity);
    }
    return obj;
  },

  create(base?: DeepPartial<WsStartChatSessionRequest>): WsStartChatSessionRequest {
    return WsStartChatSessionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WsStartChatSessionRequest>): WsStartChatSessionRequest {
    const message = createBaseWsStartChatSessionRequest();
    message.id = object.id ?? "";
    message.entity = (object.entity !== undefined && object.entity !== null)
      ? ThreadEntity.fromPartial(object.entity)
      : undefined;
    return message;
  },
};

function createBaseWsEndChatSessionRequest(): WsEndChatSessionRequest {
  return { id: "" };
}

export const WsEndChatSessionRequest: MessageFns<WsEndChatSessionRequest> = {
  encode(message: WsEndChatSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WsEndChatSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWsEndChatSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WsEndChatSessionRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: WsEndChatSessionRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<WsEndChatSessionRequest>): WsEndChatSessionRequest {
    return WsEndChatSessionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WsEndChatSessionRequest>): WsEndChatSessionRequest {
    const message = createBaseWsEndChatSessionRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseWsChatSessionRequest(): WsChatSessionRequest {
  return { id: "", request: undefined };
}

export const WsChatSessionRequest: MessageFns<WsChatSessionRequest> = {
  encode(message: WsChatSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.request !== undefined) {
      ChatSessionRequest.encode(message.request, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WsChatSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWsChatSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.request = ChatSessionRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WsChatSessionRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      request: isSet(object.request) ? ChatSessionRequest.fromJSON(object.request) : undefined,
    };
  },

  toJSON(message: WsChatSessionRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.request !== undefined) {
      obj.request = ChatSessionRequest.toJSON(message.request);
    }
    return obj;
  },

  create(base?: DeepPartial<WsChatSessionRequest>): WsChatSessionRequest {
    return WsChatSessionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WsChatSessionRequest>): WsChatSessionRequest {
    const message = createBaseWsChatSessionRequest();
    message.id = object.id ?? "";
    message.request = (object.request !== undefined && object.request !== null)
      ? ChatSessionRequest.fromPartial(object.request)
      : undefined;
    return message;
  },
};

function createBaseWsCompanyInfoSubscribeRequest(): WsCompanyInfoSubscribeRequest {
  return { companyId: 0, subscriptionId: "" };
}

export const WsCompanyInfoSubscribeRequest: MessageFns<WsCompanyInfoSubscribeRequest> = {
  encode(message: WsCompanyInfoSubscribeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.subscriptionId !== "") {
      writer.uint32(18).string(message.subscriptionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WsCompanyInfoSubscribeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWsCompanyInfoSubscribeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.subscriptionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WsCompanyInfoSubscribeRequest {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      subscriptionId: isSet(object.subscriptionId)
        ? globalThis.String(object.subscriptionId)
        : isSet(object.subscription_id)
        ? globalThis.String(object.subscription_id)
        : "",
    };
  },

  toJSON(message: WsCompanyInfoSubscribeRequest): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.subscriptionId !== "") {
      obj.subscriptionId = message.subscriptionId;
    }
    return obj;
  },

  create(base?: DeepPartial<WsCompanyInfoSubscribeRequest>): WsCompanyInfoSubscribeRequest {
    return WsCompanyInfoSubscribeRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WsCompanyInfoSubscribeRequest>): WsCompanyInfoSubscribeRequest {
    const message = createBaseWsCompanyInfoSubscribeRequest();
    message.companyId = object.companyId ?? 0;
    message.subscriptionId = object.subscriptionId ?? "";
    return message;
  },
};

function createBaseWsCompanyInfoUnsubscribeRequest(): WsCompanyInfoUnsubscribeRequest {
  return { companyId: 0, subscriptionId: "" };
}

export const WsCompanyInfoUnsubscribeRequest: MessageFns<WsCompanyInfoUnsubscribeRequest> = {
  encode(message: WsCompanyInfoUnsubscribeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.subscriptionId !== "") {
      writer.uint32(18).string(message.subscriptionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WsCompanyInfoUnsubscribeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWsCompanyInfoUnsubscribeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.subscriptionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WsCompanyInfoUnsubscribeRequest {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      subscriptionId: isSet(object.subscriptionId)
        ? globalThis.String(object.subscriptionId)
        : isSet(object.subscription_id)
        ? globalThis.String(object.subscription_id)
        : "",
    };
  },

  toJSON(message: WsCompanyInfoUnsubscribeRequest): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.subscriptionId !== "") {
      obj.subscriptionId = message.subscriptionId;
    }
    return obj;
  },

  create(base?: DeepPartial<WsCompanyInfoUnsubscribeRequest>): WsCompanyInfoUnsubscribeRequest {
    return WsCompanyInfoUnsubscribeRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WsCompanyInfoUnsubscribeRequest>): WsCompanyInfoUnsubscribeRequest {
    const message = createBaseWsCompanyInfoUnsubscribeRequest();
    message.companyId = object.companyId ?? 0;
    message.subscriptionId = object.subscriptionId ?? "";
    return message;
  },
};

function createBaseWsRunProjectAgentRequest(): WsRunProjectAgentRequest {
  return { requestId: "", request: undefined };
}

export const WsRunProjectAgentRequest: MessageFns<WsRunProjectAgentRequest> = {
  encode(message: WsRunProjectAgentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    if (message.request !== undefined) {
      RunProjectAgentRequest.encode(message.request, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WsRunProjectAgentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWsRunProjectAgentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.request = RunProjectAgentRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WsRunProjectAgentRequest {
    return {
      requestId: isSet(object.requestId)
        ? globalThis.String(object.requestId)
        : isSet(object.request_id)
        ? globalThis.String(object.request_id)
        : "",
      request: isSet(object.request) ? RunProjectAgentRequest.fromJSON(object.request) : undefined,
    };
  },

  toJSON(message: WsRunProjectAgentRequest): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.request !== undefined) {
      obj.request = RunProjectAgentRequest.toJSON(message.request);
    }
    return obj;
  },

  create(base?: DeepPartial<WsRunProjectAgentRequest>): WsRunProjectAgentRequest {
    return WsRunProjectAgentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WsRunProjectAgentRequest>): WsRunProjectAgentRequest {
    const message = createBaseWsRunProjectAgentRequest();
    message.requestId = object.requestId ?? "";
    message.request = (object.request !== undefined && object.request !== null)
      ? RunProjectAgentRequest.fromPartial(object.request)
      : undefined;
    return message;
  },
};

function createBaseWsRunProjectAgentResponse(): WsRunProjectAgentResponse {
  return { requestId: "", response: undefined };
}

export const WsRunProjectAgentResponse: MessageFns<WsRunProjectAgentResponse> = {
  encode(message: WsRunProjectAgentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    if (message.response !== undefined) {
      RunProjectAgentResponse.encode(message.response, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WsRunProjectAgentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWsRunProjectAgentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.response = RunProjectAgentResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WsRunProjectAgentResponse {
    return {
      requestId: isSet(object.requestId)
        ? globalThis.String(object.requestId)
        : isSet(object.request_id)
        ? globalThis.String(object.request_id)
        : "",
      response: isSet(object.response) ? RunProjectAgentResponse.fromJSON(object.response) : undefined,
    };
  },

  toJSON(message: WsRunProjectAgentResponse): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.response !== undefined) {
      obj.response = RunProjectAgentResponse.toJSON(message.response);
    }
    return obj;
  },

  create(base?: DeepPartial<WsRunProjectAgentResponse>): WsRunProjectAgentResponse {
    return WsRunProjectAgentResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WsRunProjectAgentResponse>): WsRunProjectAgentResponse {
    const message = createBaseWsRunProjectAgentResponse();
    message.requestId = object.requestId ?? "";
    message.response = (object.response !== undefined && object.response !== null)
      ? RunProjectAgentResponse.fromPartial(object.response)
      : undefined;
    return message;
  },
};

function createBaseWsChatSessionResponse(): WsChatSessionResponse {
  return { id: "", response: undefined, error: undefined };
}

export const WsChatSessionResponse: MessageFns<WsChatSessionResponse> = {
  encode(message: WsChatSessionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.response !== undefined) {
      ChatSessionResponse.encode(message.response, writer.uint32(18).fork()).join();
    }
    if (message.error !== undefined) {
      writer.uint32(26).string(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WsChatSessionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWsChatSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.response = ChatSessionResponse.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.error = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WsChatSessionResponse {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      response: isSet(object.response) ? ChatSessionResponse.fromJSON(object.response) : undefined,
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    };
  },

  toJSON(message: WsChatSessionResponse): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.response !== undefined) {
      obj.response = ChatSessionResponse.toJSON(message.response);
    }
    if (message.error !== undefined) {
      obj.error = message.error;
    }
    return obj;
  },

  create(base?: DeepPartial<WsChatSessionResponse>): WsChatSessionResponse {
    return WsChatSessionResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WsChatSessionResponse>): WsChatSessionResponse {
    const message = createBaseWsChatSessionResponse();
    message.id = object.id ?? "";
    message.response = (object.response !== undefined && object.response !== null)
      ? ChatSessionResponse.fromPartial(object.response)
      : undefined;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseWsAck(): WsAck {
  return { ackId: "" };
}

export const WsAck: MessageFns<WsAck> = {
  encode(message: WsAck, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ackId !== "") {
      writer.uint32(10).string(message.ackId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WsAck {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWsAck();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ackId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WsAck {
    return {
      ackId: isSet(object.ackId)
        ? globalThis.String(object.ackId)
        : isSet(object.ack_id)
        ? globalThis.String(object.ack_id)
        : "",
    };
  },

  toJSON(message: WsAck): unknown {
    const obj: any = {};
    if (message.ackId !== "") {
      obj.ackId = message.ackId;
    }
    return obj;
  },

  create(base?: DeepPartial<WsAck>): WsAck {
    return WsAck.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WsAck>): WsAck {
    const message = createBaseWsAck();
    message.ackId = object.ackId ?? "";
    return message;
  },
};

function createBaseWsResponse(): WsResponse {
  return { type: undefined };
}

export const WsResponse: MessageFns<WsResponse> = {
  encode(message: WsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.type?.$case) {
      case "runProjectAgent":
        WsRunProjectAgentResponse.encode(message.type.value, writer.uint32(802).fork()).join();
        break;
      case "chatSession":
        WsChatSessionResponse.encode(message.type.value, writer.uint32(810).fork()).join();
        break;
      case "ack":
        WsAck.encode(message.type.value, writer.uint32(818).fork()).join();
        break;
      case "threadActivityUpdate":
        ThreadsActivityUpdate.encode(message.type.value, writer.uint32(826).fork()).join();
        break;
      case "threadProgressUpdate":
        ThreadProgressUpdate.encode(message.type.value, writer.uint32(834).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.type = { $case: "runProjectAgent", value: WsRunProjectAgentResponse.decode(reader, reader.uint32()) };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.type = { $case: "chatSession", value: WsChatSessionResponse.decode(reader, reader.uint32()) };
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.type = { $case: "ack", value: WsAck.decode(reader, reader.uint32()) };
          continue;
        }
        case 103: {
          if (tag !== 826) {
            break;
          }

          message.type = {
            $case: "threadActivityUpdate",
            value: ThreadsActivityUpdate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 104: {
          if (tag !== 834) {
            break;
          }

          message.type = { $case: "threadProgressUpdate", value: ThreadProgressUpdate.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WsResponse {
    return {
      type: isSet(object.runProjectAgent)
        ? { $case: "runProjectAgent", value: WsRunProjectAgentResponse.fromJSON(object.runProjectAgent) }
        : isSet(object.run_project_agent)
        ? { $case: "runProjectAgent", value: WsRunProjectAgentResponse.fromJSON(object.run_project_agent) }
        : isSet(object.chatSession)
        ? { $case: "chatSession", value: WsChatSessionResponse.fromJSON(object.chatSession) }
        : isSet(object.chat_session)
        ? { $case: "chatSession", value: WsChatSessionResponse.fromJSON(object.chat_session) }
        : isSet(object.ack)
        ? { $case: "ack", value: WsAck.fromJSON(object.ack) }
        : isSet(object.threadActivityUpdate)
        ? { $case: "threadActivityUpdate", value: ThreadsActivityUpdate.fromJSON(object.threadActivityUpdate) }
        : isSet(object.thread_activity_update)
        ? { $case: "threadActivityUpdate", value: ThreadsActivityUpdate.fromJSON(object.thread_activity_update) }
        : isSet(object.threadProgressUpdate)
        ? { $case: "threadProgressUpdate", value: ThreadProgressUpdate.fromJSON(object.threadProgressUpdate) }
        : isSet(object.thread_progress_update)
        ? { $case: "threadProgressUpdate", value: ThreadProgressUpdate.fromJSON(object.thread_progress_update) }
        : undefined,
    };
  },

  toJSON(message: WsResponse): unknown {
    const obj: any = {};
    if (message.type?.$case === "runProjectAgent") {
      obj.runProjectAgent = WsRunProjectAgentResponse.toJSON(message.type.value);
    } else if (message.type?.$case === "chatSession") {
      obj.chatSession = WsChatSessionResponse.toJSON(message.type.value);
    } else if (message.type?.$case === "ack") {
      obj.ack = WsAck.toJSON(message.type.value);
    } else if (message.type?.$case === "threadActivityUpdate") {
      obj.threadActivityUpdate = ThreadsActivityUpdate.toJSON(message.type.value);
    } else if (message.type?.$case === "threadProgressUpdate") {
      obj.threadProgressUpdate = ThreadProgressUpdate.toJSON(message.type.value);
    }
    return obj;
  },

  create(base?: DeepPartial<WsResponse>): WsResponse {
    return WsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WsResponse>): WsResponse {
    const message = createBaseWsResponse();
    switch (object.type?.$case) {
      case "runProjectAgent": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "runProjectAgent", value: WsRunProjectAgentResponse.fromPartial(object.type.value) };
        }
        break;
      }
      case "chatSession": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "chatSession", value: WsChatSessionResponse.fromPartial(object.type.value) };
        }
        break;
      }
      case "ack": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "ack", value: WsAck.fromPartial(object.type.value) };
        }
        break;
      }
      case "threadActivityUpdate": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "threadActivityUpdate", value: ThreadsActivityUpdate.fromPartial(object.type.value) };
        }
        break;
      }
      case "threadProgressUpdate": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "threadProgressUpdate", value: ThreadProgressUpdate.fromPartial(object.type.value) };
        }
        break;
      }
    }
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
